document.addEventListener('click', function(e) {
  if (e.target && e.target.classList.contains('fc__toggles__list__item-title')) {
    const target = e.target.parentElement.querySelector('.fc__toggles__list__item-content');
    if (target.classList.contains('is-visible')) {
      target.style.display = 'none';
      target.classList.remove('is-visible');
      e.target.classList.remove('is-open');
    } else {
      target.style.display = 'block';
      target.classList.add('is-visible');
      e.target.classList.add('is-open');
    }
  }
});
